var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c(
            "button",
            {
              staticClass: "btn-info",
              attrs: { type: "button" },
              on: { click: _vm.consultar }
            },
            [
              _c("i", { staticClass: "fa fa-search" }),
              _c("span", [_vm._v("Consultar")])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-success",
              attrs: { type: "button" },
              on: { click: _vm.exportar }
            },
            [
              _c("i", { staticClass: "fa fa-file-excel-o" }),
              _c("span", [_vm._v("Excel")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select" }, [
              _c("div", { staticClass: "select-field" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.bodega_id,
                        expression: "form.bodega_id"
                      }
                    ],
                    attrs: { name: "bodega", id: "bodega" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "bodega_id",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [_vm._v("Todas")]),
                    _vm._v(" "),
                    _vm._l(_vm.bodegas, function(bodega) {
                      return _c(
                        "option",
                        { key: bodega.id, domProps: { value: bodega.id } },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(bodega.descripcion) +
                              "\n                "
                          )
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("label", { attrs: { for: "bodega" } }, [_vm._v("Sucursal")])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-8" }, [
            _c("div", { staticClass: "form-field select2" }, [
              _c(
                "div",
                { staticClass: "select2-field" },
                [
                  _c("v-select", {
                    attrs: {
                      placeholder: "Seleccione...",
                      id: "cliente",
                      multiple: "",
                      options: _vm.clientes,
                      label: "nombre"
                    },
                    on: { search: _vm.searchCliente, input: _vm.inputClientes },
                    model: {
                      value: _vm.selectedClientes,
                      callback: function($$v) {
                        _vm.selectedClientes = $$v
                      },
                      expression: "selectedClientes"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "cliente" } }, [
                    _vm._v("Cliente")
                  ])
                ],
                1
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card mt-2" }, [
      _c("div", { staticClass: "card__content" }, [
        _c(
          "div",
          {
            staticClass: "table-responsive",
            staticStyle: { "max-height": "300px" }
          },
          [
            _c("table", { staticClass: "custom-table" }, [
              _c("thead", [
                _c(
                  "tr",
                  [
                    _c("th", [_vm._v("Cliente")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Valor Total")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Valor de Pagos")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Total Pagado")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Saldo Total")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Por Vencer")]),
                    _vm._v(" "),
                    _vm._l(_vm.dias, function(dia) {
                      return _c("th", { key: dia }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(dia) +
                            " días\n              "
                        )
                      ])
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.proyecciones, function(proyeccion, index) {
                  return _c(
                    "tr",
                    { key: index },
                    [
                      _c("td", [
                        _c("strong", [_vm._v(_vm._s(proyeccion.nombre))])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.moneyFormat(proyeccion.valor_total)) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.moneyFormat(proyeccion.valor_pagos)) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.moneyFormat(proyeccion.total_pagado)) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.moneyFormat(proyeccion.saldo_total))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.moneyFormat(proyeccion.por_vencer)) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.dias, function(dia) {
                        return _c("td", { key: dia }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.moneyFormat(proyeccion["a_" + dia])) +
                              "\n              "
                          )
                        ])
                      })
                    ],
                    2
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("tfoot", [
                _c(
                  "tr",
                  [
                    _c("th", { attrs: { scope: "row" } }, [
                      _vm._v("\n                Totales\n              ")
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.moneyFormat(
                              _vm.lodash.sumBy(_vm.proyecciones, function(o) {
                                return parseFloat(o.valor_total)
                              })
                            )
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.moneyFormat(
                              _vm.lodash.sumBy(_vm.proyecciones, function(o) {
                                return parseFloat(o.valor_pagos)
                              })
                            )
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.moneyFormat(
                              _vm.lodash.sumBy(_vm.proyecciones, function(o) {
                                return parseFloat(o.total_pagado)
                              })
                            )
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.moneyFormat(
                              _vm.lodash.sumBy(_vm.proyecciones, function(o) {
                                return parseFloat(o.saldo_total)
                              })
                            )
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.moneyFormat(
                              _vm.lodash.sumBy(_vm.proyecciones, function(o) {
                                var valor = parseFloat(o.por_vencer)
                                if (isNaN(valor)) {
                                  valor = 0
                                }
                                return valor
                              })
                            )
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.dias, function(dia) {
                      return _c("td", { key: dia }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.moneyFormat(
                                _vm.lodash.sumBy(_vm.proyecciones, function(o) {
                                  return parseFloat(o["a_" + dia])
                                })
                              )
                            )
                          )
                        ])
                      ])
                    })
                  ],
                  2
                )
              ])
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Reporte de Proyección de Cartera")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4e41a8c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4e41a8c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ReporteProyeccionCartera.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-c4e41a8c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ReporteProyeccionCartera.vue
// module chunks = 0